import React, { useState } from "react";
import { newsArticlProps } from "./newsArticle.types";
import useWindowDimemsions from "../../hooks/useWindowDimesnions";
import NerAanalysis from "../NerAanalysis/NerAanalysis";
import NewsClasses from "../NewsClasses/NewsClasses";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import "./newsArticleSearch.scss";

/**
 * The `NewsArticleSearch` component displays details of a news article including its summary,
 * detected events, and the actual news content.
 *
 * This function is called in \src\Component\Search\Search.tsx
 */
const NewsArticleSearch = ({ singleNews }: newsArticlProps) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const { width }: any = useWindowDimemsions();
  const xsWidth = 576;
  const objLength = Object.keys(singleNews || {}).length;
  const heightStyle =
    width && width < xsWidth && objLength === 0
      ? { minHeight: "100px", maxHeight: "100px" }
      : width && width < xsWidth && objLength > 0
      ? { minHeight: "25vh", maxHeight: "75vh" }
      : { minHeight: "75vh", maxHeight: "75vh" };

  return (
    <div className={`na-panel col-md-6 mb-2 ${width && width > 768 ? "" : "mb-4"}`}>
      <div className="na-inner" style={heightStyle}>

        {/* ── Summary ── */}
        <section className="na-section">
          <div className="na-section-header">
            <span className="na-section-icon">&#128196;</span>
            <h6 className="na-section-title">Summary</h6>
          </div>
          <div className="na-section-body">
            {singleNews.News_Summary ? (
              <p className="na-summary-text">{singleNews.News_Summary}</p>
            ) : (
              <p className="na-empty">No summary available.</p>
            )}
          </div>
        </section>

        {/* ── Organizations (NER) ── */}
        {singleNews.News_ner_org_freq && (
          <section className="na-section">
            <div className="na-section-header">
              <span className="na-section-icon">&#127970;</span>
              <h6 className="na-section-title">Organizations</h6>
            </div>
            <div className="na-section-body">
              <NerAanalysis data={singleNews.News_ner_org_freq} />
            </div>
          </section>
        )}

        {/* ── News Type (Classes) ── */}
        {singleNews.News_Classes && (
          <section className="na-section">
            <div className="na-section-header">
              <span className="na-section-icon">&#127991;</span>
              <h6 className="na-section-title">News Type</h6>
            </div>
            <div className="na-section-body">
              <NewsClasses data={singleNews.News_Classes} />
            </div>
          </section>
        )}

        {/* ── Events Detected ── */}
        <section className="na-section">
          <div className="na-section-header">
            <span className="na-section-icon">&#9889;</span>
            <h6 className="na-section-title">Events Detected</h6>
          </div>
          <div className="na-section-body">
            {singleNews.Events_Detected && singleNews.Events_Detected !== "Null" ? (
              <ul className="na-events-list" />
            ) : (
              <p className="na-empty">No events detected.</p>
            )}
          </div>
        </section>

        {/* ── Actual Article button ── */}
        {singleNews.Sentiment_Analyzed_news && (
          <div className="na-footer">
            <button
              className="na-read-btn"
              type="button"
              onClick={() => setIsModalOpen(true)}
            >
              Read Full Article
            </button>
          </div>
        )}

      </div>

      {/* ── Modal ── */}
      <Dialog
        open={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        maxWidth="md"
        fullWidth
        className="full-article-modal"
      >
        <DialogContent className="modal-content">
          <div className="modal-header">
            <h6>Actual News Article</h6>
            <IconButton
              aria-label="close"
              onClick={() => setIsModalOpen(false)}
              className="close-button"
            >
              <CloseIcon />
            </IconButton>
          </div>
          <div className="modal-article-content">
            <div
              className="article-text"
              dangerouslySetInnerHTML={{ __html: singleNews.Sentiment_Analyzed_news }}
            />
          </div>
        </DialogContent>
      </Dialog>
    </div>
  );
};

export default NewsArticleSearch;
